import GeneralEvents from './GeneralEvents';

export default GeneralEvents;
